import $ from 'jquery';

const SELECTOR = '.img-loader';

class ImageLoader {
	constructor ( el ) {
		this.tagName = el.tagName;

		this.$el = $( el );
		this.src = this.$el.attr( 'data-src' );
		this.preload = this.$el.attr( 'data-preload' );

		if ( this.src && this.preload ) {
			this.setPreview();
		}
	}

	setSrc () {
		let image = new Image();

		image.onload = () => {
			if ( 'IMG' == this.tagName ) {
				this.$el.attr( 'src', this.src).removeClass( 'img-loader__imgblur' );
			} else {
				this.$el.find( '.img-loader__bg' ).css( 'backgroundImage', `url(${this.src})` );
				this.$el.find( '.img-loader__preview' ).remove();
			}

			this.$el.addClass( 'img-loader--loaded' );
		}

		image.src = this.src;
	}

	setPreview () {
		if ( 'IMG' == this.tagName ) {
			this.$el.attr( 'src', this.preload).addClass( 'img-loader__imgblur' );
		} else {
			// this.$el.append( '<div class="img-loader__bg"></div>' );
			this.$el.append( `<div class="img-loader__preview" style="background-image: url(${this.preload})"></div>` );
		}

		this.setSrc();
	}
}

$( document ).ready( () => {
	$( SELECTOR ).each( ( index, el ) => {
		new ImageLoader( el );
	} );
} );
